import { Controller } from "@hotwired/stimulus"
import Choices from "choices.js"

export default class extends Controller {
    static targets = ["select"]
    static values = {
        options: Object,
    }

    connect() {
        if (this.choices) return

        console.log("searchable_select", this.selectTarget)

        const defaults = {
            searchEnabled: true,
            removeItemButton: true,
            shouldSort: false,
            placeholder: true,
            placeholderValue: "Search…",
            searchPlaceholderValue: "Type to search…",
            itemSelectText: "",
        }

        const options = { ...defaults, ...(this.hasOptionsValue ? this.optionsValue : {}) }

        this.choices = new Choices(this.selectTarget, options)
    }

    disconnect() {
        this.choices?.destroy()
        this.choices = null
    }
}